import { ReactElement } from 'react';
import { ConfirmationModal } from '../../../components/ConfirmationModal';

interface IProps {
  isShown: boolean;
  email: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const RemoveUserModal = ({ isShown, email, onCancel, onConfirm }: IProps): ReactElement => {
  return (
    <ConfirmationModal
      showModal={isShown}
      confirmationHeader={'confirm_user_remove'}
      confirmationQuestion={'remove_user_from_workspace'}
      confirmationQuestionValues={{ email: email }}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmationYes={'remove_user'}
      loaderKey='remove-user-button'
    />
  );
};
